<template>
	<div>
		<div class="enterprise">
			<div class="enterprise-title">企业文化</div>
			<div class="enterprise-list">
				<div>
					<img src="../../assets/img/enterprise-big-1.png" alt="">
					<!-- <img v-else src="../../assets/img/enterprise-1.png" alt=""> -->
					<div class="tag" @click="changeIdx(0)">
						<div>
							<div class="tag-title">互助</div>
							<div>最好的满足就是给别人以满足</div>
						</div>
					</div>
				</div>
				<div>
					<img src="../../assets/img/enterprise-big-2.png" alt="">
					<!-- <img v-else src="../../assets/img/enterprise-2.png" alt=""> -->
					<div class="tag" @click="changeIdx(1)">
						<div>
							<div class="tag-title">坚守</div>
							<div>每一位客户都赤诚以待 将产品和服务做到极致</div>
						</div>
					</div>
				</div>
				<div>
					<img src="../../assets/img/enterprise-big-3.png" alt="">
					<!-- <img v-else src="../../assets/img/enterprise-3.png" alt=""> -->
					<div class="tag" @click="changeIdx(2)">
						<div>
							<div class="tag-title">分享</div>
							<div>开放和拥抱是公司永恒的主题</div>
						</div>
					</div>
				</div>
				<div>
					<img src="../../assets/img/enterprise-4.png" alt="">
					<div class="tag" @click="changeIdx(3)">
						<div>
							<div class="tag-title">成长</div>
							<div>共同成长是公司对每一位客户和员工的承诺</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default({
		data(){
			return{
				idx:3
			}
		},
		methods:{
			changeIdx(i){
				this.idx=i
			}
		}
	})
</script>

<style lang="scss" scoped>
	.enterprise{
		padding:.41rem .27rem;
		.enterprise-title{
			font-size: .38rem;
			color: #000000;
			line-height: .48rem;
			font-weight: 600;
			text-align: center;
		}
		.enterprise-list{
			margin-top:.2rem;
			//display:flex;
			>div{
				margin-top:.2rem;
				width:100%;
				height:5.5rem;
				position: relative;
				transition: all .3s linear;
				&:nth-child(1){
					margin-top:0;
				}
				>img{
					width:100%;
					height:100%;
					border-radius: .1rem;
					object-fit:cover;
				}
				.tag{
					height:100%;
					width:100%;
					position: absolute;
					left:0;
					top:0;
					display:flex;
					flex-direction: column;
					justify-content: flex-end;
					box-sizing: border-box;
					padding-bottom:.27rem;
					color:#fff;
					background: rgba(0,0,0,0.32) linear-gradient(180deg, rgba(0,0,0,0) 68%, #000000 100%);
					border-radius: .1rem;
					>div{
						font-size: .24rem;
						color: rgba(255,255,255,0.85);
						line-height: .38rem;
						padding-left:.41rem;
						.tag-title{
							font-size: .41rem;
							color: #FFFFFF;
							line-height: .55rem;
							font-weight: 600;
							display:inline-block;
							padding:.07rem 0;
							border-bottom:0.01rem solid #FFFFFF;
							margin-bottom:.2rem;
						}
					}
				}
			}
		}
		
	}
</style>